import useFetchApi from "@/api/hooks/useFetchApi";
import { useMutateApi } from "@/api/hooks/useMutateApi";
import usePageData from "@/api/hooks/usePageData";
import GlobeLoading from "@/components/GlobeLoading";
import { Formik } from "formik";
import React from "react";
import { Helmet } from "react-helmet-async";
import * as yup from "yup";


const ContactUs: React.FC = () => {

  const {
    data: userForm,
    isLoading: isLoading,

  } = useFetchApi({
    url: '/v1/user-form/' + '6745dae77e8e448acef1c251' + '/action',
    service: 'CMS_PROC'
  });

  const {
    data: pageData,
    page,
    localization,
    isLoading: isLoadingPageData,
  } = usePageData();

  const {
    _post
  } = useMutateApi({
    Service: 'CMS_PROC',
  });


  return (
    <div>
      <Helmet>
        <title>
          {page?.name}
        </title>
        <meta name="description" content={localization?.dict["description"]?.value || ""} />
      </Helmet>
      <GlobeLoading isLoading={isLoading || isLoadingPageData} />
      {/* Sub Page Banner */}
      <section className="sub-page-banner text-center"
        style={{
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundImage: `url(https://minimar.b-cdn.net/uploads/images/thumbnail-1732697010445-954265950.jpg)`,
        }}
      >
        <div className="overlay" style={{ background: "rgba(0,0,0,0.5)" }}></div>
        <div className="container">
          <h1 className="entry-title">
            {page?.name}
          </h1>
          <br />
          <p>
            {localization?.dict["description"].value}
          </p>
        </div>
      </section>

      {/* Sub Page Content */}
      <div id="sub-page-content" className="clearfix">
        <div className="container">


          <div className="row">
            <div className="col-md-8">
              <h2 className="light bordered"  >
                <div dangerouslySetInnerHTML={{
                  __html:
                    localization?.dict["title"].value
                }} />
              </h2>
              {/* Contact Form */}
              <div className="contact-form2 clearfix">
                <Formik
                  initialValues={{
                    ...userForm?.fields.reduce((acc: any, field: any) => {
                      acc[field.column_name] = "";
                      return acc;
                    }, {}),
                  }}
                  validationSchema={yup.object().shape(
                    userForm && {
                      ...userForm.fields.filter((x: any) => x.isMeta !== true).
                        reduce((acc: any, field: any) => {
                          let schema: any = null;
                          let rules = field.rules;
                          let field_type = field.type;
                          if (field_type === 'bool') {
                            schema = yup.boolean();
                          }
                          else if (field_type === 'number') {
                            schema = yup.number();
                          }
                          else if (field_type === 'date') {
                            schema = yup.date();
                          }
                          else {
                            schema = yup.string();
                          }

                          for (let i = 0; i < rules.length; i++) {


                            if (rules[i].rule === 'required') {

                              schema = schema.required(
                                rules[i].error_message
                              );

                            }

                            if (rules[i].rule === 'min' || rules[i].rule === "minlength") {
                              schema = schema.min(rules[i].value, rules[i].error_message);

                            }

                            if (rules[i].rule === 'max' || rules[i].rule === "maxlength") {
                              schema = schema.max(rules[i].value, rules[i].error_message);
                            }

                            if (rules[i].rule === 'pattern') {
                              schema = schema.matches(new RegExp(rules[i].value), rules[i].error_message);

                            }
                          }
                          return {
                            ...acc,
                            [field.column_name]: schema
                          }
                        }, {}),
                      ...userForm?.module?.kvkk_documents?.reduce((acc: any, document: any) => {
                        acc["doc_" + document.id] = yup.boolean().oneOf([true], 'You must accept the terms and conditions');
                        return acc;
                      }, {})
                    }
                  )}

                  onSubmit={(values) => {
                    let kvkk_documents = values.kvkk.map((x: any) => {
                      let dt = userForm?.module?.kvkk_documents.find((doc: any) => doc.id === x.split('_')[1]);
                      return {
                        ...dt,
                        is_accepted: true
                      };
                    });
                    let tmp = {
                      ...values,
                      kvkk_documents
                    };
                    delete tmp.kvkk
                    _post('/v1/user-form/' + '6745dae77e8e448acef1c251' + '/action', tmp).then((response) => {
                      alert('Form submitted successfully');
                    })
                      .catch((error) => {
                        alert('Error submitting form');
                      })
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form
                      name="contact_form"
                      id="contact-form"
                      className="contact-form2 row"
                      onSubmit={handleSubmit}>
                      {userForm?.fields
                        .filter((field: any) => field.isMeta !== true)
                        .map((field: any) => {
                          let props = {
                            type: field.type === 'string' ? 'text' : field.type,
                            name: field.column_name,
                            placeholder: field.name,
                            value: values[field.column_name],
                            onChange: handleChange,
                            onBlur: handleBlur
                          };

                          if (field.rules.find((rule: any) => rule.rule === 'minlength' && Number(rule.value) >= 100)) {
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '5px',
                                }}
                              >
                                <textarea
                                  className="col-12"
                                  key={field.column_name}
                                  {...props}
                                  style={{
                                    border: errors[field.column_name] && touched[field.column_name] ? '1px solid red' : '1px solid #ccc',
                                  }}
                                />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    gap: '5px',
                                  }}
                                >
                                  {errors[field.column_name] && touched[field.column_name] && (
                                    <div className="text-danger">{errors[field.column_name] as string}</div>
                                  )}
                                  <span>
                                    {values[field.column_name]?.length || 0}/{field.rules.find((x: any) => x.rule === 'maxlength').value}
                                  </span>
                                </div>
                              </div>
                            )
                          }

                          return (
                            <div
                              className="form-input col-6"
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '5px',
                                marginBottom: '10px',

                              }}
                            >
                              <input
                                key={field.column_name}
                                {...props}
                                style={{
                                  border: errors[field.column_name] && touched[field.column_name] ? '1px solid red' : '1px solid #ccc',
                                }}
                              />
                              {errors[field.column_name] && touched[field.column_name] && (
                                <div className="text-danger">{errors[field.column_name] as string}</div>
                              )}
                            </div>
                          )
                        })}
                      {userForm?.module?.kvkk_documents?.map((
                        document: any,
                        index: number
                      ) => {
                        return (
                          <div
                            key={document.id + 'doc' + index}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              gap: '5px',
                              width: "100%"
                            }}>
                            <input type="checkbox" name={"kvkk"} id={document.id}
                              value={"doc_" + document.id}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <label
                              style={{
                                color: 'black',
                                width: "100%"
                              }}
                              htmlFor={document.id}
                              dangerouslySetInnerHTML={{
                                __html: document.text.replace(/<name>(.*?)<\/name>/g, document.attributes.name)
                                  .replace(/<link>(.*?)<\/link>/g, '<a href="https://www.kvkk.info.tr' + document.attributes.dosya_url + '" target="_blank">$1</a>')
                              }}
                            >
                            </label>
                          </div>
                        )
                      })}
                      <button type="submit" className="btn btn-primary" style={{ marginTop: 10 }}>
                        {
                          localization?.dict["form.submit"].value
                        }
                      </button>
                    </form>
                  )}
                </Formik>
              </div>
            </div>

            <div className="col-md-4">
              <h2 className="light bordered">
                <div dangerouslySetInnerHTML={{
                  __html:
                    localization?.dict["contact"].value
                }} />
              </h2>
              <div className="get-in-touch-widget">
                <ul className="list-unstyled">
                  <li><i className="fa fa-phone"></i>
                    <a href={`tel:${pageData?.Contact?.find((record: any) => record.title === 'phone')?.text}`}>
                      {pageData?.Contact?.find((record: any) => record.title === 'phone')?.text}
                    </a>
                  </li>
                  <li><i className="fa fa-envelope"></i>
                    <a href={`mailto:${pageData?.Contact?.find((record: any) => record.title === 'mail')?.text}`}>
                      {pageData?.Contact?.find((record: any) => record.title === 'mail')?.text}
                    </a>
                  </li>
                  <li

                  ><i className="fa fa-globe"></i>
                    <a href={pageData?.Contact?.web}>
                      {pageData?.Contact?.find((record: any) => record.title === 'web')?.text}
                    </a>
                  </li>
                  <li><i className="fa fa-clock-o"></i>
                    {pageData?.Contact?.find((record: any) => record.title === 'work_period')?.text}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



export default ContactUs;
